// extracted by mini-css-extract-plugin
module.exports = {"userName":"user-name-dropdown-menu_component_userName__IDOHi"};